import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';

// "Confirm status change" — shown when a manual status pick skips unfinished runner stages or moves backwards.
export default function StatusConfirmDialog({ pending, onCancel, onConfirm, busy }) {
  const [reason, setReason] = useState('');
  if (!pending) return null;
  return (
    <Dialog open={!!pending} onOpenChange={(o) => { if (!o) { setReason(''); onCancel(); } }}>
      <DialogContent className="max-w-md" data-testid="status-confirm-dialog">
        <DialogHeader><DialogTitle>Confirm status change</DialogTitle></DialogHeader>
        <div className="text-sm text-slate-700">
          Move from <b>{pending.fromLabel || '—'}</b> to <b data-testid="status-confirm-target">{pending.toLabel}</b>?
        </div>
        <div className="text-xs text-amber-900 bg-amber-50 border border-amber-300 rounded p-3 space-y-1" data-testid="status-confirm-unfinished">
          <div className="flex items-center gap-1.5 font-semibold"><AlertTriangle size={13} /> Not finished in the workflow yet:</div>
          <ul className="list-disc pl-5">{pending.unfinished.map((u) => <li key={u}>{u}</li>)}</ul>
          <div className="text-amber-800">Those stages will be marked done as a manual override.</div>
        </div>
        <textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="status-confirm-reason"
          className="w-full border border-slate-300 rounded p-2 text-sm" placeholder="Reason (required — saved in the audit log)" />
        <div className="flex justify-end gap-2">
          <button type="button" onClick={() => { setReason(''); onCancel(); }} data-testid="status-confirm-cancel"
            className="px-3 py-1.5 text-sm rounded border border-slate-300 hover:bg-slate-50">Cancel</button>
          <button type="button" disabled={!reason.trim() || busy} onClick={() => onConfirm(reason.trim())} data-testid="status-confirm-submit"
            className="px-3 py-1.5 text-sm rounded bg-[#D35400] text-white font-semibold disabled:opacity-40">Confirm change</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
